import React from 'react';
import { getFormData } from '../../common';
import { EverestAdminRepository } from '../../repository';
import { NavigationBar } from './NavigationBar';

class MountainDetail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mountainId: props.match.params.mountainId,
      mountain: {}
    };

    this.everestRepository = new EverestAdminRepository();
  }

  componentDidMount() {
    const mountainId = this.state.mountainId;
    this.everestRepository.findMountain({ mountainId }, (data) => {
      this.setState({ mountain: data });
    });
  }

  onSubmit(e) {
    e.preventDefault();
    const formData = getFormData(e.target);
    this.everestRepository.updateMountain(formData, () => {
      window.Toast.info("Completed!");
    });
  }

  onClickDelete(e) {
    e.preventDefault();
    const confirm = window.confirm("Are you sure?");
    if (confirm) {
      const mountainId = this.state.mountainId;
      this.everestRepository.deleteMountain({ mountainId }, () => {
        window.Toast.info("Completed!");
        window.history.back();
      });
    }
  }

  render() {
    return (
      <React.Fragment>
        <NavigationBar />

        <br />
        <div className={"container"}>
          <form className={"form-text-align-default"} onSubmit={this.onSubmit.bind(this)}>
            <input name={"mountainId"} type={"hidden"} defaultValue={this.state.mountainId}></input>
            <div className={"form-group"}>
              <label>mountainName</label>
              <input name={"name"} className={"form-control"} type={"text"} defaultValue={this.state.mountain.name}></input>
            </div>

            {this.state.mountain.id !== undefined && (
              <>
                {!this.state.mountain.deleted && (
                  <div className={"form-group"}>
                    <button className={"btn btn-primary"} type={"submit"}>수정</button>&nbsp;
                    <button className={"btn btn-danger"} onClick={this.onClickDelete.bind(this)}>삭제</button>
                  </div>
                )}
                {this.state.mountain.deleted && (
                  <p style={{ color: "#f00" }}>삭제 완료</p>
                )}
              </>
            )}
          </form>
        </div>

        <br />
        <br />
        <MountainLocationList mountainId={this.state.mountainId} />

      </React.Fragment>
    );
  }
}

class MountainLocationList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mountainId: props.mountainId,
      mountainLocations: [],
      region1: "",
      region1s: [],
      region2s: []
    };

    this.everestRepository = new EverestAdminRepository();
  }

  componentDidMount() {
    const mountainId = this.state.mountainId;
    this.everestRepository.searchMountainLocation({ mountainId }, (data) => {
      this.setState({ mountainLocations: data.content });
    });
    this.everestRepository.searchRegion1({}, (data) => {
      this.setState({ region1s: data.content });
    });
  }

  onClickDelete(e) {
    e.preventDefault();
    const mountainId = this.state.mountainId;
    const { region1, region2 } = e.target.dataset;
    const confirm = window.confirm("Area you sure?");
    if (confirm) {
      this.everestRepository.deleteMountainLocation({ mountainId, region1, region2 }, () => {
        window.Toast.info("Completed!");
        this.everestRepository.searchMountainLocation({ mountainId }, (data) => {
          this.setState({ mountainLocations: data.content });
        });
      });
    }
  }

  onChangeRegion1(e) {
    e.preventDefault();
    const region1 = e.target.value;
    this.everestRepository.searchRegion2({ region1 }, (data) => {
      this.setState({ region1, region2s: data.content });
    });
  }

  onChangeRegion2(e) {
    e.preventDefault();
    const { mountainId, region1 } = this.state;
    const region2 = e.target.value;
    this.everestRepository.createMountainLocation({ mountainId, region1, region2 }, () => {
      window.Toast.info("Completed!");
      this.everestRepository.searchMountainLocation({ mountainId }, (data) => {
        this.setState({ mountainLocations: data.content });
      });
    });
  }

  render() {
    return (
      <>
        <div className={"container"}>
          <div className={"row"}>
            <div className={"col-3"}>
              <div className={"form-group"}>
                <select name={"region1"} className={"form-control"} onChange={this.onChangeRegion1.bind(this)}>
                  <option>-선택-</option>
                  {(this.state.region1s || []).map((item) => (
                    <option key={item.code} value={item.code}>{item.name}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className={"col-3"}>
              <div className={"form-group"}>
                <select name={"region1"} className={"form-control"} onChange={this.onChangeRegion2.bind(this)}>
                  <option>-선택-</option>
                  {this.state.region2s.map((item) => (
                    <option key={item.code} value={item.code}>{item.name}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className={"col-3"}></div>
            <div className={"col-3"}></div>
          </div>
          <div className={"row"}>
            <div className={"col-6"}>
              <table className={"table table-sm table-middle"}>
                <thead>
                  <tr>
                    <th>소재지</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.mountainLocations.map((item, idx) => (
                    <tr key={idx}>
                      <td>
                        {item.locationText}&nbsp;
                        <a href={"/"}
                          className={"badge badge-pill badge-danger"}
                          data-region1={item.region1}
                          data-region2={item.region2}
                          onClick={this.onClickDelete.bind(this)}>delete</a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className={"col-6"}></div>

          </div>
        </div>
      </>
    );
  }
}

export { MountainDetail };
